<template>
  <el-select
    v-model="search"
    filterable
    remote
    placeholder="Buscar medicamento"
    class="app-medication-search"
    :loading="loading"
    :disabled="disabled"
    :remote-method="handleRemoteSearch"
    @input="handleItemSelect">
    <el-option
      v-for="medication in medications"
      :key="medication.reference"
      :label="medication.display"
      :value="medication.reference"
      :class="{ 'app-medication-select__option--recommended': medication.recommended }" />
  </el-select>
</template>
<script>
export default {
  name: 'AppMedicationSearch',
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    medications: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      search: this.value.display || ''
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue.reference !== oldValue.reference) {
        this.search = newValue.display;
      }
    }
  },
  methods: {
    handleRemoteSearch(value) {
      this.$emit('search', value);
    },
    handleItemSelect(value) {
      this.$emit('input', JSON.parse(JSON.stringify(this.medications.find(m => m.reference === value))));
    }
  }
};
</script>
